import * as React from 'react';

export class TopBarDropdownOption extends React.Component<any, any> {
  onClick = () => this.props.onClick(this.props.option);

  render() {
    const { option } = this.props;

    return (
      <li role='button' onClick={this.onClick}>
        {option.name}
      </li>
    );
  }
}
